export const conditionErrorTypes = {
  conditionIncomplete: 'conditionIncomplete',
}

export const appliesWhenValues = {
  all: 'all',
  atLeastOne: 'at_least_one',
  none: 'none',
}

export const itemScope = 'item'

export const initCriterion = {
  field: '',
  match_type: '',
  match_value: '',
  match_values: null,
  match_case: false,
  date_range_start: null,
  date_range_end: null,
  days_value: null,
  min_value: null,
  max_value: null,
  match_currency: null,
}

export const initCondition = {
  scope: '',
  item_context: null,
  applies_when: null,
  applies_to_action: false,
  criteria: [initCriterion],
}
